module.exports = __webpack_public_path__ + "u14.no2.5553945f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u14.no2.jpg
// module id = +iOU
// module chunks = 0